<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/">Моё оборудование</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ this.inventory.sku }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" disabled="disabled" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Наименование" />
          <text-input v-model="form.room" :error="form.errors.room" class="pb-8 pr-6 w-full lg:w-1/2" label="Кабинет/Помещение" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    inventory: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.inventory.name,
        room: this.inventory.room,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/inventories/${this.inventory.id}`)
    },
  },
}
</script>
